import { Controller } from "@hotwired/stimulus"

const VISIBILITY_STATES = new Set([ "private", "public" ])

export default class extends Controller {
  static targets = [ "status", "message" ]
  static values = {
    current: String,
    privateMessage: String,
    publicMessage: String
  }

  connect() {
    this.renderState(this.currentValue)
  }

  update(event) {
    const visibility = event.detail?.value
    if (!VISIBILITY_STATES.has(visibility)) return

    this.currentValue = visibility
    this.renderState(visibility)
  }

  renderState(visibility) {
    const isPublic = visibility === "public"
    this.statusTarget.classList.toggle("ec-visibility-pill--public", isPublic)
    this.statusTarget.classList.toggle("ec-visibility-pill--private", !isPublic)
    this.statusTarget.textContent = isPublic ? "Public" : "Private"
    this.messageTarget.textContent = isPublic ? this.publicMessageValue : this.privateMessageValue
  }
}
